import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import TerminalListDataTableHandler from '@Modules/terminalManagementSystem/gabManagement/containers/dataTableHandlers/terminal/salesPoint/TerminalListDataTableHandler';
import AddressFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/salesPoint/address/AddressFormHandler';
import IdentificationFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/salesPoint/identification/IdentificationFormHandler';
import SalesPointFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/salesPoint/SalesPointFormHandler';

import React from 'react';

const tabHeaders = ['Identification', 'Adresse', 'Liste Terminaux'];

const SalesPointPage = () => {
  const tabContents = React.useMemo(
    () => [<IdentificationFormHandler />, <AddressFormHandler />, <TerminalListDataTableHandler />],
    []
  );
  return (
    <>
      <Heading size="md" my={'2rem'}>
        Point de Vente
      </Heading>
      <SalesPointFormHandler />
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy />
    </>
  );
};

export default SalesPointPage;
